<template lang="html">
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex
        xs12
        lg10
        xl8
        mx-auto
      >
        <v-layout wrap>
          <v-flex
            v-if="back"
            xs12
            my-3
          >
            <v-layout
              align-center
              ma-0
            >
              <v-btn
                fab
                small
                color="primary"
                @click="goBack"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <span class="ml-2 caption grey--text">Back</span>
            </v-layout>
          </v-flex>
          <slot />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'SiContainer',
  props: {
    back: [ String, Boolean ]
  },
  methods: {
    goBack () {
      if (typeof this.back === 'string') this.$router.replace(this.back)
      this.$emit('back')
    }
  }
}
</script>

<style lang="css" scoped>

</style>
